import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import logoSocioSalud from '../../../images/logo-sociosalud.png';
import logoUsal from '../../../images/logo-usal.png';
import logoCiencias from '../../../images/logo-usal-ciencias.png';
import background from '../../../images/background.jpeg';

export default function AuthShell({ children }) {
  const imgStyle = { maxWidth: '150px', height: 'auto', margin: '5px' };
  const footerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '175px', width: '500px', margin: 'auto' };

  return (
    <Box
      sx={{
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        minHeight: '100vh',
      }}
    >
      <Container sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Grid container sx={{ flexGrow: 1 }} alignItems="center" justifyContent="center">
          <Grid item>{children}</Grid>
        </Grid>

        <Box sx={footerStyle}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={4} sx={{ textAlign: 'left' }}>
              <img src={logoCiencias} alt="Facultad de Ciencias" style={imgStyle} />
            </Grid>
            <Grid item xs={4} sx={{ textAlign: 'center' }}>
              <img src={logoUsal} alt="Universidad de Salamanca" style={imgStyle} />
            </Grid>
            <Grid item xs={4} sx={{ textAlign: 'right' }}>
              <img src={logoSocioSalud} alt="SocioSalud" style={imgStyle} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
